import { CredentialsDataGrid } from 'src/common/credentials/CredentialsDataGrid/CredentialsDataGrid';
import { useCredentialClearState } from 'src/common/credentials/useCredentialClearState';

export function MemberCredentialsRoute() {
  useCredentialClearState();

  return <CredentialsDataGrid category="Team" />;
}
